
import { call, put, takeLatest, select } from 'redux-saga/effects'
import {
    getCampaignListApi,
    pauseResumeUpdateCampaign,
    getCampaignsCountApi
} from '../../network/requests'
import {
    getCampaignListSuccess,
    getCampaignListError,
    changeStatusSuccess,
    changeStatusError,
    getCampaignsCountSuccess,
    getCampaignsCountError
} from './viewCampaignReducer'
import { showLoader, hideLoader } from "../../components/Loader/loaderReducer"
import { showNudge, SEVEARITY_CONTS } from "../../components/Nudge/nudgeReducer"
import { showSummaryAction } from '../../components/CampaignSummary/campaignSummaryReducer'
import { getProductSegmentData } from '../CreateCampaigns/helpers'

function* getCampaignList(action) {
    try {
        const data = yield call(getCampaignListApi, action.payload);
        if (data?.length > 0) {
            yield put(getCampaignListSuccess(data))
        } else {
            yield put(getCampaignListSuccess([]))
        }
    } catch (e) {
        yield put(getCampaignListError(e))
    }
}

function* getCampaignsCount(action) {
    try {
        const response = yield call(getCampaignsCountApi);
        yield put(getCampaignsCountSuccess(response))
    } catch (e) {
        yield put(getCampaignsCountError(e))
    }
}

function* changeStatus(action) {
    yield put(showLoader())
    try {
        const data = yield call(pauseResumeUpdateCampaign, action.payload.campaignData)
        const response = yield call(getCampaignsCountApi);
        yield put(getCampaignsCountSuccess(response))
        yield put(changeStatusSuccess({ data, index: action.payload.index }))
        if (action.payload.fromSummary) {
            yield put(showSummaryAction({ ...data }))
        }
        yield put(showNudge({
            message: "Campaign Updated Successfully",
            type: SEVEARITY_CONTS.success
        }))
    } catch (e) {
        yield put(changeStatusError(e))
        yield put(showNudge({
            message: e.message,
            type: SEVEARITY_CONTS.error
        }))
    } finally {
        yield put(hideLoader())
    }
}

function* createCampaignSaga() {
    yield takeLatest('ViewCampaigns/getCampaignList', getCampaignList)
    yield takeLatest('ViewCampaigns/changeStatus', changeStatus)
    yield takeLatest('ViewCampaigns/getCampaignsCount', getCampaignsCount);
}

export default createCampaignSaga